export const defaultProps = {
  easing: "cubic-bezier(0.5, 0, 0, 1)",
  distance: "30px",
  duration: 1000,
  desktop: true,
  mobile: true,
};

export const targetElements = [
  {
    element: ".section-title",
    animation: {
      delay: 300,
      distance: "0px",
      origin: "bottom",
    },
  },
  {
    element: ".hero-title",
    animation: {
      delay: 500,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".hero-cta",
    animation: {
      delay: 1000,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".hero-intro",
    animation: {
      delay: 750,
      origin: window.innerWidth > 768 ? "left" : "bottom",
    },
  },
  {
    element: ".pixel-stage",
    animation: {
      delay: 850,
      origin: window.innerWidth > 768 ? "right" : "bottom",
    },
  },
  {
    element: ".vibe-card",
    animation: {
      delay: 500,
      interval: 120,
      origin: "bottom",
    },
  },
  {
    element: ".section-note",
    animation: {
      delay: 650,
      origin: "bottom",
    },
  },
  {
    element: ".social-links",
    animation: {
      delay: 800,
      origin: "bottom",
    },
  },
  {
    element: ".contact-wrapper",
    animation: {
      delay: 800,
      origin: "bottom",
    },
  },
];
